export default "__VITE_ASSET__DilqoJsm__"